export default function unflattenServiceTypes(flatServiceTypes) {
  let preSelectedServiceTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const ret = {};
  const serviceTypes = [...flatServiceTypes];
  serviceTypes.sort((a, b) => {
    // Check if one is parent and the other is child, to sort parents first
    if (a.parent_id === null && b.parent_id !== null) return -1;
    if (a.parent_id !== null && b.parent_id === null) return 1;
    // If both are parents or both are children, sort alphabetically by name
    return a.name.localeCompare(b.name);
  });
  serviceTypes.forEach(serviceType => {
    if (!serviceType.parent_id) {
      if (!ret[serviceType.id]) {
        // Parent w/ no entry - Create
        ret[serviceType.id] = {
          label: serviceType.name,
          value: serviceType.id,
          initial: false,
          children: []
        };
      } else if (!ret[serviceType.id].label) {
        // Parent created by child - Fill label
        ret[serviceType.id].label = serviceType.name;
      }
    } else if (ret[serviceType.parent_id]) {
      // Child w/ parent entry - Add to parent's children
      ret[serviceType.parent_id].children.push({
        label: serviceType.name,
        value: serviceType.id,
        initial: preSelectedServiceTypes === null || preSelectedServiceTypes === void 0 ? void 0 : preSelectedServiceTypes.includes(serviceType.id)
      });
    } else {
      // Child w/ no parent entry - Create both
      ret[serviceType.parent_id] = {
        label: null,
        value: serviceType.parent_id,
        initial: false,
        children: [{
          label: serviceType.name,
          value: serviceType.id,
          initial: preSelectedServiceTypes === null || preSelectedServiceTypes === void 0 ? void 0 : preSelectedServiceTypes.includes(serviceType.id)
        }]
      };
    }
  });
  return Object.values(ret);
}
//# sourceMappingURL=unflattenServiceTypes.js.map